import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Hero } from '../components/Hero';
import { Form } from '../components/Form';

import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

export const UnfinishedLoanEstimate = ({hibisId}) => {

  return (
    <>
      <Header />
      <Hero image="oskar-addiko.jpg" xPos="71%" yPos="28%" />
      <div className="addiko-app">
        <Container>
            <Row>
                <Col md={6} className="p-3">
                    <h1>Hvala, ker ste pokazali zanimanje za Addiko kredit!</h1>
                    <p className="text-left">
                      <b>Kmalu vas bomo poklicali in z vami uredili vse potrebno.</b>
                    </p>
                    <p className="text-left">
                      Do takrat vam želimo lep dan!
                    </p>
                    <p className="text-left text-small">
                        Kjerkoli in kadarkoli, vedno z vami!<br />
                        Addiko banka
                    </p>
                </Col>
                <Col md={1} className="p-3 d-none d-md-block">
                    &nbsp;
                </Col>
                <Col md={5} className="p-3">
                  <Form guid="a247eab1-e16a-45fa-b2c9-53a7dca8f4b6" hibisId={hibisId} />
                </Col>
            </Row>
        </Container>
      </div>      
      <Footer />
    </>
  );
}